import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class NRADetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>NRA CET (National Recruitment Agency Common Eligibility Test) is a screening/preliminary exam that will be conducted by the newly approved NRA to shortlist candidates for various Group-B and C non-technical and non-gazetted posts. Candidates will now have to appear for one single entrance exam, i.e, CET, for various Government Exams such as Bank, SSC & Railways. 
                    </p>
                    </ScrollAnimation>	
                   
               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">Features:</h5><br/>							
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />NRA CET will be conducted to screen candidates at the first level only for SSC, IBPS, and RRB recruitment
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Based on NRA CET score, final selection will be made through separate specialised tier-II/tier-III exams to be conducted by the respective recruitment agency (SSC/IBPS/RRB)
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />There will be separate online NRA CETs for graduates, Class 12 and Class 10 candidates
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />Candidates will be able to schedule their tests and choose exam centre of their choice
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />NRA CET score of a candidate will be valid for three years
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Best available NRA CET score of three years to be considered for selection/recruitment
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />NRA CET scores can be shared with central government, state governments, Union Territories (UTs), Public Sector Undertakings (PSUs) and private sector
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" />Through NRA CET, candidates will get the opportunity to compete for many posts by appearing for just one exam.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">Eligibility: </h5><br/>							
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Educational qualification:</b> NRA CET will be conducted at three levels-Class 10, Class 12, and Graduation. This means that candidates who have cleared Class 10, Class 12, and Graduation are all eligible to apply.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Age limit:</b> There will be an upper age limit for the exam. The age limit will differ as per the post for which the candidate will apply. However, there will be relaxations in the upper age limit for candidates belonging to reserved categories such as Scheduled Caste (SC), Scheduled Tribe (ST), Other Backward Class (OBC), Persons with Disability (PwD), etc.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /><b>Number of attempts:</b> There is no bar on the number of attempts and one can take for the exam, subject to the upper age limit prescribed
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <h5 className="mb-0 mt-2">Syllabus: </h5><br/>
                            <p><b>NRA CET</b> will include questions from 4 categories. They are:</p>						
                                <ul>
                                    <li>General Reasoning and Intelligence</li>
                                    <li>Quantitative Aptitude </li>
                                    <li>General Awareness</li>
                                    <li>Language</li>
                                </ul>
                            </blockquote>
                        </div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
                        <h5 className="mb-0 mt-2">Exam Pattern: </h5>
                        <p>The Exam Pattern for NRA CET (SSC, RRB & IBPS) will have 4 sections with 50 questions each. Every question will contain 1 mark each and the duration is expected to be 120 Minutes. </p>
                    </ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
					<table>
						<tr>
							<th>Name of the Section</th>
							<th>No. of questions</th>
							<th>Total Marks</th>
							<th>Total Duration</th>
						</tr>
						<tr>
							<td>General Intelligence and Reasoning</td>
							<td style={{textAlign:'center'}}>50</td>
							<td style={{textAlign:'center'}}>50</td>
							<td rowspan="4">120 Minutes </td>
						</tr>
						<tr>
							<td>General Knowledge	</td>
							<td style={{textAlign:'center'}}>50</td>
							<td style={{textAlign:'center'}}>50</td>
						</tr>
						<tr>
                        <td>Quantitative Aptitude	</td>
							<td style={{textAlign:'center'}}>50</td>
							<td style={{textAlign:'center'}}>50</td>
						</tr>
						<tr>
                        <td>English 	</td>
							<td style={{textAlign:'center'}}>50</td>
							<td style={{textAlign:'center'}}>50</td>
						</tr>
						<tr>
                        <td>Total	</td>
							<td style={{textAlign:'center'}}><b>200</b></td>
							<td style={{textAlign:'center'}}><b>200</b></td>
							<td></td>
						</tr>
					</table>
					</ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
                        <p><b>The Test Score attained in NRA CET will be valid for upto 3 years.</b></p>
                    </ScrollAnimation><br/>
                    <ScrollAnimation animateIn="fadeInRight">
                    <h5 className="mb-0 mt-2">How MIET helps you stand out from the crowd?</h5>
                        <p>Entrance exams can be overwhelming, but at MIET we help you stay on the top of your game.</p>
                        <ul>
                            <li>Live Interactive Classes with experienced faculties</li>
                            <li>Different modes of teaching to help you pick the concepts easily</li>
                            <li>Competitive edge over your fellow competitors</li>
                            <li>Disciplined and pro-learning environment</li>
                            <li>One-on-one Attention and extensive doubt clearing sessions</li>
                            <li>Comprehensive study materials and continuous testing</li>
                            <li>Modern Infrastructure</li>
                        </ul>
                    </ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
                  </div>
		      </div>
			  <Sidebar courseRestriction="NRA CET"/>
		    </div>
		  </div>
		</div>

        }
}

export default NRADetails